import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, { Component } from 'react';
import FlatButton from './FlatButton';
import CircleButton from './CircleButton';

import $ from 'jquery';
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

class TableList extends Component{
    constructor(props){
        super(props);

        this.setTable = this.setTable.bind(this);
        this.resetTable = this.resetTable.bind(this);
        this.btnAction = this.btnAction.bind(this);
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    setTable(){
        this.$el = $(this.el);

        let table = this.$el.DataTable({
            columns: this.props.columns,
            oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"
				},
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: this.props.filter,
			scrollY:false,//"20em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
        });
    }

    resetTable(){
        this.$el = $(this.el);
        this.$el.DataTable().destroy();
    }

    btnAction(e, variables = null){
		e.preventDefault();
        
		var clickFn = e.target.name !== undefined ? e.target.name 
					: e.target.parentNode.name !== undefined ? e.target.parentNode.name 
					: e.target.parentNode.parentNode.name !== undefined ? e.target.parentNode.parentNode.name 
                    : e.target.parentNode.parentNode.parentNode.name !== undefined ?  e.target.parentNode.parentNode.parentNode.name
                    : e.target.parentNode.parentNode.parentNode.parentNode.name;

        if(this.props[clickFn] !== undefined){
            this.props[clickFn](variables);
        }
	}

    render(){
        return(
            <table className="" width={'100%'} id='table' ref={el => this.el = el}>
                <tbody>
                    {this.props.list.map((row, i) => (
                        <tr key={i}>
                            {row.map((col, j) => (
                                col.type === 'text' ?
                                    <td key={j}>
                                        {col.value}
                                    </td> :
                                col.type === 'array' ?
                                    <td key={j}>
                                        {col.value.map((item, k) => (
                                            <div key={k}>{item}</div>
                                        ))}
                                    </td> :
                                col.type === 'button' ?
                                    <td key={j} className='text-center'>
                                        <FlatButton 
                                            disabled={col.properties.disabled}
                                            fill={col.properties.fill}
                                            highlight={col.properties.highlight}
                                            icon={col.properties.icon}
                                            size={col.properties.size}
                                            title={col.properties.title}
                                            variables={col.properties.variables}
                                            action={this.btnAction}
                                            name={col.properties.clickFn}
                                        />
                                    </td> :
                                col.type === 'options' ?
                                    <td key={j} className="d-flex">
                                        {this.props.buttons.map((b, k) => (
                                            <CircleButton 
                                                action={this.btnAction}
                                                disabled={b.disabled}
                                                icon={b.icon}
                                                key={k}
                                                name={b.clickFn}
                                                title={b.title}
                                                variables={col.properties.variables}
                                            />
                                        ))}
                                    </td> 
                                :
                                    <td key={j}>
                                        {col.value}
                                    </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
                
        )
    }
}

export default TableList;